<template>
  <widget-step-page
    :btn-next-disabled="isBtnNextDisabled"
    :btn-prev-disabled="false"
    :on-btn-prev-clicked="onBtnPrevClicked"
    :on-btn-next-clicked="onBtnNextClicked"
  >
    <template #content>
      <div class="px-4 pb-14 pt-8">
        <div class="d-flex flex-column">
          <template v-if="availableFilialList.length > 0">
            <span
              class="mb-4"
            >Выберите адрес:</span>

            <v-radio-group
              v-model="localFilialId"
              dense
              class="mt-0 pt-0 mb-3"
            >
              <template v-for="filial in availableFilialList">
                <x-radio
                  :value="filial.id"
                >
                  <template #label>
                    <span style="font-size: 20px; color: #2A3948">
                      {{ filial.name }}
                    </span>
                  </template>
                </x-radio>
              </template>
            </v-radio-group>

            <cumulative-info-panel />
          </template>

          <!-- Если нет никаких доступных времён -->
          <filial-not-available-panel v-else />
        </div>
      </div>
    </template>
  </widget-step-page>
</template>

<script>
import WidgetStepPage from "@/components/page-template/WidgetStepPage"
import {isNullOrUndefined} from "@/plugins/object-helpers"
import {
  WIDGET_STEP__SELECT_DOCTOR,
  WIDGET_STEP__SELECT_SPEC_OR_DOCTOR,
  WIDGET_STEP__SELECT_SERVICE
} from "@/plugins/consts"
import XRadio from "@/components/x-env/radio/XRadio"
import {mapGetters} from "vuex"
import NoteTooltip from "@/components/tooltip/NoteTooltip"
import CumulativeInfoPanel from "@/components/panels/CumulativeInfoPanel.vue"
import FilialNotAvailablePanel from "@/components/pages/steps/select-filial/FilialNotAvailablePanel.vue"

export default {
  components: {
    FilialNotAvailablePanel,
    CumulativeInfoPanel,
    NoteTooltip,
    WidgetStepPage,
    XRadio,
  },
  data() {
    return {
      localFilialId: null
    }
  },
  computed: {
    ...mapGetters([
      'filialId',
      'filialList',
      'doctorName',
      'doctorNote',
      'specialityName',
      'doctorFilialId',
      'currentFilialDoctorsList',
      'otherFilialDoctorsList',
      'currentFilialSpecialitiesList',
      'otherFilialSpecialitiesList',
      'doctorFilialsList'
    ]),
    //Список филиалов с доступной записью: используются только те филиалы, на которых пришло "ближайшее время"
    availableFilialList() {
      let result = []
      if (!isNullOrUndefined(this.doctorFilialId)) {
        const allDoctors = [...this.currentFilialDoctorsList, ...this.otherFilialDoctorsList]
        const doctorFilial = allDoctors.find(it => it.id === this.doctorFilialId)
        if (doctorFilial !== null) {
          result = this.filialList.filter(it => doctorFilial.availableFilialIdList.includes(it.id))
        }
      } else {
        const allDoctorFilials = [...this.doctorFilialsList]
        result = this.filialList.filter(it => allDoctorFilials.map(itt=>itt.id).includes(it.id))
      }
      return result
    },
    isBtnNextDisabled() {
      return isNullOrUndefined(this.localFilialId)
    }
  },
  async mounted() {
    this.localFilialId = this.filialId
  },
  methods: {
    onBtnPrevClicked() {
      this.$store.commit('setFilialId', null)
      //Если сейчас заполнен doctorFilialId, значит, предыдущим был шаг выбора врача. Если нет - шаг выбора "специальности или врача"
      this.$emit('change-step', isNullOrUndefined(this.doctorFilialId)
        ? WIDGET_STEP__SELECT_SPEC_OR_DOCTOR
        : WIDGET_STEP__SELECT_DOCTOR)
    },

    onBtnNextClicked() {
      if (this.isBtnNextDisabled) {
        return
      }

      this.$store.commit('setFilialId', this.localFilialId)
      this.$emit('change-step', WIDGET_STEP__SELECT_SERVICE)
    },
  }
}
</script>

<style scoped>

</style>